import CountryCareerSection from "./CountryCareerSection";
import CountryCostSection from "./CountryCostSection";
import CountryCoursesSection from "./CountryCoursesSection";
import CountryFaqSection from "./CountryFaqSection";
import CountryFinalCta from "./CountryFinalCta";
import CountryHero from "./CountryHero";
import CountryLifestyleSection from "./CountryLifestyleSection";
import CountryOverview from "./CountryOverview";
import CountryProcessSection from "./CountryProcessSection";
import CountryUniversitiesSection from "./CountryUniversitiesSection";
import SeoHead from "../common/SeoHead";

function CountryPageTemplate({ country }) {
  return (
    <>
      <SeoHead
        title={country.seo.title}
        description={country.seo.description}
        path={`/study-in/${country.slug}`}
        keywords={[
          `study in ${country.name}`,
          `${country.name} universities for international students`,
          `${country.name} student visa guidance`,
          `${country.name} admission counselling`
        ]}
      />

      <CountryHero country={country} />
      <CountryOverview country={country} />
      <CountryCostSection country={country} />
      <CountryProcessSection country={country} />
      <CountryCoursesSection country={country} />
      <CountryUniversitiesSection country={country} />
      <CountryCareerSection country={country} />
      <CountryLifestyleSection country={country} />
      <CountryFaqSection country={country} />
      <CountryFinalCta country={country} />
    </>
  );
}

export default CountryPageTemplate;
